export default __webpack_public_path__ + "static/media/bulkSkuUpload.de2b948b.csv";